module.exports = __webpack_public_path__ + "static/media/petco.06a4f5f0.jpg";